import { parserCtx, schemaCtx } from '@milkdown/core'
import type { Ctx } from '@milkdown/ctx'
import { DOMSerializer } from '@milkdown/prose/model'

/**
 * Static HTML for a snippet body, parsed and serialized with the editor's own
 * schema so the preview reads exactly like the script around it. Never enters
 * the document.
 */
export function snippetBodyHtml(ctx: Ctx, markdown: string): string {
  const doc = ctx.get(parserCtx)(markdown)
  const holder = document.createElement('div')
  holder.appendChild(
    DOMSerializer.fromSchema(ctx.get(schemaCtx)).serializeFragment(doc.content)
  )
  // A default <a> would navigate the SPA away mid-edit, and the schema copies
  // hrefs verbatim, so drop any scheme a stored body should never carry.
  holder.querySelectorAll('a').forEach((anchor) => {
    if (!/^(https?:|mailto:|tel:)/i.test(anchor.getAttribute('href') ?? '')) {
      anchor.removeAttribute('href')
    }
    anchor.target = '_blank'
    anchor.rel = 'noopener noreferrer'
  })
  return holder.innerHTML
}
